<div class="out">
  <div *ngIf="scenes">

    <div class="title step intro_d" (click)="toogle('intro')">
      <div class="title">
        Overview Steeps <img src="assets/images/expand.svg" class="delete expand" [ngClass]="{colapse:colapsed['intro']}" kzLib />
      </div>
    </div>
    <div *ngIf="!colapsed['intro']" class="">
      <div *ngFor="let step of scenes; let i = index" class="step intro_d" [ngClass]="{intro:act=='intro' && scene_index==i}" (click)="playScene('intro',i)">
        <img *ngIf="!progress[i] || !progress[i].intro" class="check" src="assets/images/check.svg" alt="">
        <img *ngIf="progress[i] && progress[i].intro" class="check" src="assets/images/done.svg" alt="">

        <div *ngIf="step" class="tx">
          {{step.name}}
          <div class="pd" *ngIf="progress[i] && progress[i].intro">{{progress[i].intro|date:'MM/dd hh:mm'}}</div>
        </div>
        <img *ngIf="bShowRecUI" src="assets/images/delete.svg" class="delete" (click)="delIntroStep(i)">
      </div>

      <!-- <div *ngIf="bShowAdd" class="step" [style.background]="'#A9D6EB'" (click)="addScene()">
        <div class="tx abs_center">
          Add Scene
        </div>
      </div> -->
    </div>

    <div class="title step describe_d" (click)="toogle('describe')">
      <div class="title"> Detail Steeps <img src="assets/images/expand.svg" class="delete expand" [ngClass]="{colapse:colapsed['describe']}" kzLib />
      </div>
    </div>
    <div *ngIf="!colapsed['describe']" class="">
      <div *ngFor="let step of scenes; let i = index" class="step describe_d" [ngClass]="{describe:act=='describe' && scene_index==i}" (click)="playScene('describe',i)">
        <img *ngIf="step.describe && (!progress[i] || !progress[i].describe)" class="check" src="assets/images/check.svg" alt="">
        <img *ngIf="step.describe && progress[i] && progress[i].describe" class="check" src="assets/images/done.svg" alt="">

        <img *ngIf="!step.describe" class="check" src="assets/images/check_g.svg" alt="">
        <div class="tx">
          {{step.name}}
          <div class="pd" *ngIf="progress[i] && progress[i].describe">{{progress[i].describe|date:'MM/dd hh:mm'}}</div>
        </div>
        <img *ngIf="bShowRecUI && step.describe && step.describe.movie_name" src="assets/images/delete.svg" class="delete" (click)="delTeacherActVideo(i,'describe')">
      </div>
    </div>

    <div class="title step problems_d" (click)="toogle('problems')">
      <div class="title"> Red flags<img src="assets/images/expand.svg" class="delete expand" [ngClass]="{colapse:colapsed['problems']}" kzLib />
      </div>
    </div>
    <div *ngIf="!colapsed['problems']" class="">
      <div *ngFor="let step of scenes; let i = index" class="step problems_d" [ngClass]="{problems:act=='problems' && scene_index==i}" (click)="playScene('problems',i)">
        <img *ngIf="step.problems && (!progress[i] || !progress[i].problems)" class="check" src="assets/images/check.svg" alt="">
        <img *ngIf="step.problems && progress[i] && progress[i].problems" class="check" src="assets/images/done.svg" alt="">
        <img *ngIf="!step.problems" class="check" src="assets/images/check_g.svg" alt="">
        <div class="tx">
          {{step.name}}
          <div class="pd" *ngIf="progress[i] && progress[i].problems">{{progress[i].problems|date:'MM/dd hh:mm'}}</div>

        </div>
        <img *ngIf="bShowRecUI && step.problems && step.problems.movie_name" src="assets/images/delete.svg" class="delete" (click)="delTeacherActVideo(i,'problems')">
      </div>
    </div>
  </div>


</div>
